/**
 * TO'LIQ ALMASHTIRUVCHI `PUT` — ish vaqtidagi ikkinchi qatlam.
 *
 * <h2>⚠️ Nima uchun TypeScript yetmaydi</h2>
 * Tip tekshiruvi maydon tushib qolishini faqat tana AYNAN o'sha tip bilan
 * yozilganda ushlaydi. Tana boshqa joyda yig'ilib tarqatib berilsa
 * (`{ ...oldingi, name }`) tekshiruv ochiq qoladi va yetishmagan maydon
 * serverga «bu ustunni tozala» degan buyruq bo'lib boradi: `UPDATE` har
 * ustunga qiymat yozadi, Jackson esa yuborilmagan maydonni `null` qiladi.
 *
 * Shuning uchun ro'yxat tarmoqqa chiqishdan OLDIN shu yerda o'lchanadi.
 * ⚠️ `in` bilan tekshiriladi, `!== undefined` bilan emas: `undefined`
 * qiymatli kalitni `JSON.stringify` tashlab yuboradi, ya'ni «maydon bor»
 * degan xulosa yolg'on bo'lardi.
 */
export function requireEveryField<T extends object>(
  body: T,
  fields: readonly (keyof T)[],
  what: string,
): void {
  const missing = fields.filter((field) => !(field in body) || body[field] === undefined)
  if (missing.length > 0) {
    throw new Error(
      `${what}: PUT to'liq almashtiradi, so'rovda maydon yetishmayapti — ${missing.join(', ')}`,
    )
  }
}
